<template>
  <nav class="navbar navbar-taskbar pt-1 pb-0 px-0 border-top-1 fixed-bottom d-flex align-items-center justify-content-around d-md-none">
    <router-link
      :to="{name: 'tasks.today', params: { userId }}"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-star"></i>
      </span>
      <span class="small">
        Today
      </span>
    </router-link>
    <router-link
      :to="{name: 'tasks.upcoming', params: { userId }}"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-calendar"></i>
      </span>
      <span class="small">
        Upcoming
      </span>
    </router-link>
    <a
      href="#"
      class="btn btn-primary text-center text-decoration-none text-white position-relative"
      @click.prevent="createNewTask()"
      style="top:-3px; width:15%; max-width: 60px;"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-plus"></i>
      </span>
    </a>
    <router-link
      :to="{name: 'tasks.anytime', params: { userId }}"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-th-list"></i>
      </span>
      <span class="small">
        Anytime
      </span>
    </router-link>
    <router-link
      :to="{name: 'tasks.complete', params: { userId }}"
      class="d-block text-center text-decoration-none py-1"
      style="width:15%"
    >
      <span class="h4 font-weight-normal d-block mb-0">
        <i class="fa fa-fw fa-book"></i>
      </span>
      <span class="small">
        Complete
      </span>
    </router-link>
  </nav>
</template>


<script>
import $ from 'jquery'

export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  mounted () {
    $('body').prepend($(this.$el))
  },
  methods: {
    createNewTask () {
      $(window).trigger('createNewTask.requested')
    }
  }
}
</script>